import { render } from "./document-view-small.vue?vue&type=template&id=15f09948&scoped=true&lang=html"
import script from "./document-view-small.vue?vue&type=script&lang=js"
export * from "./document-view-small.vue?vue&type=script&lang=js"

import "./document-view-small.vue?vue&type=style&index=0&id=15f09948&scoped=true&lang=scss"

import exportComponent from "/build/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-15f09948"]])

export default __exports__